export const URL_CAPTCHA = '/captcha'
export const URL_USER = '/user'
export const URL_USER_VERIFY = '/user/verify'
export const URL_USER_LOGON = '/user/logon'
export const URL_USER_ADMIN_LOGON = '/user/adminLogon'
export const URL_USER_PROXIES = '/user/proxies'
export const URL_USER_PROFILE = '/user/profile'
export const URL_USER_PROFILE_REQUEST = '/user/profile/request'
export const URL_USER_CHANGE_PASSWORD = '/user/changePassword'
export const URL_USER_RESET_PASSWORD = '/user/resetPassword'
export const URL_USER_RESET_PASSWORD_CONFIRMED = '/user/resetPasswordConfirmed'
export const URL_USER_SUBSCRIPTIONS = '/user/subscriptions'
export const URL_ORGANIZATION = '/organization'
export const URL_ORGANIZATION_DRAFTS = '/organizationDrafts'
export const URL_ORGANIZATION_DRAFT = '/organizationDraft'
export const URL_ORGANIZATION_DRAFT_REQUEST = '/organizationDraft/request'
export const URL_ORGANIZATION_REQUESTS = '/organizationRequests'
export const URL_USER_PROXYS = '/user/proxies'
export const URL_USERS = '/users'
export const URL_USERS_RESET_CONFIRM_EMAIL = '/users/resetConfirmEmail'
export const URL_FILES = '/files'
export const URL_ORGANIZATIONS = '/organizations'
export const URL_PROXIES = '/proxies'

export const URL_USER_REQUESTS = '/userRequests'
export const URL_TRADE_REQUESTS = '/tradeRequests'
export const URL_MANAGEMENT = '/management'
// export const URL_MANAGEMENT_STATISTICS = '/management/statistics'
export const URL_DICTIONARIES = '/dictionaries'
export const URL_PRODUCTS = '/products'
export const URL_PRODUCT_SECTIONS = '/productSections'

// export const URL_PRODUCT_SECTIONS = '/productSections'
export const URL_RELEVANCE_FILE = '/static/info.json'
export const URL_MAILING = '/mailing'
export const URL_LOTS = '/lots'
export const URL_LOTS_COLLECTIONS = '/lots/collection'
export const URL_SESSIONS = '/sessions'
export const URL_STATIC_PAGES = '/staticPages'
export const URL_SYSTEM = '/system'
export const URL_SCHEDULER = '/scheduler'
export const URL_TEMPLATES = '/templates'

export const URL_PAYMENTS = '/payments'
